import axios from "axios"
import { useForm } from "react-hook-form"
import emailContext from "./emailcontext";
import { useContext } from "react";
import { useState } from "react";
import './addarticle.css';

export default function Addarticle() {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [file, setFile] = useState(null)
  function handleFileChange(e) { setFile(e.target.files[0]) }
  const [email, setEmail] = useContext(emailContext)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const opinionValue = watch("opinion", "")
  const isAcadassoc = opinionValue?.trim().toLowerCase() === "acadassoc"
  const isCsa = opinionValue?.trim().toLowerCase() === "csa"
  const needsPosition = isAcadassoc || isCsa
  const needsSubject = isAcadassoc
  const needsCandidate = isAcadassoc || isCsa

  async function onsub(data) {
    setIsSubmitting(true);
    try {
      const cleanedData = {
        ...data,
        title: needsCandidate ? null : data.title,
        subject: needsSubject ? data.subject : null,
        position: needsPosition ? (data.position ? data.position.toLowerCase() : null) : null,
        candidatename: needsCandidate ? data.candidatename : null,
      };

      let imageUrl = null;
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        const uploadRes = await axios.post(
          "https://dojma-website-2pip.onrender.com/upload",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        imageUrl = uploadRes.data.url;
      }

      const payload = { ...cleanedData, image: imageUrl };

      await axios.post("https://dojma-website-2pip.onrender.com/data", payload);

      alert("Article uploaded successfully!");
      reset();
      setFile(null);
    } catch (err) {
      console.log(err);
      alert("Failed to upload article. Please check the console for details.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <form className="parentform" onSubmit={handleSubmit(onsub, (errors) => console.log("Validation Errors:", errors))}>

        <div>
          <label>full name of the author:</label>
          <input {...register("name", { required: { value: true, message: "required" } })} />
          {errors.name && <p className="error">{errors.name.message}</p>}
        </div>

        {!needsCandidate && (
          <div>
            <label>title of article:</label>
            <input {...register("title", { required: { value: !needsCandidate, message: "required" } })} />
            {errors.title && <p className="error">{errors.title.message}</p>}
          </div>
        )}

        <div>
          <label>type of article:</label>
          <input {...register("opinion", {
            pattern: { value: /^(ONION|OPINION|ACADASSOC|CSA)$/i, message: "Invalid type entered." },
            required: { value: true, message: "required" },
            setValueAs: v => v.trim().toUpperCase()
          })} />
          <p className="hint">Accepted values: <strong>ONION</strong>, <strong>OPINION</strong>, <strong>ACADASSOC</strong>, <strong>CSA</strong></p>
          {errors.opinion && <p className="error">{errors.opinion.message}</p>}
        </div>

        <div>
          <label>date:</label>
          <input {...register("date", {
            pattern: { value: /\b[A-Z][a-zA-Z]*\s\d+,\s\d+\b/, message: "Invalid date format." },
            required: { value: true, message: "required" }
          })} />
          <p className="hint">Format: <strong>Month Day, Year</strong> — e.g. April 29, 2025</p>
          {errors.date && <p className="error">{errors.date.message}</p>}
        </div>

        {/* Subject — only shown & required for ACADASSOC */}
        {needsSubject && (
          <div>
            <label>subject of acadassoc candidate:</label>
            <input {...register("subject", {
              pattern: { value: /^(CS|ECE|EEE|ENI)$/i, message: "Invalid subject entered." },
              required: { value: true, message: "required" }
            })} />
            <p className="hint">Accepted values: <strong>CS</strong>, <strong>ECE</strong>, <strong>EEE</strong>, <strong>ENI</strong></p>
            {errors.subject && <p className="error">{errors.subject.message}</p>}
          </div>
        )}

        {/* Position — only shown & required for ACADASSOC or CSA */}
        {needsPosition && (
          <div>
            <label>position of candidate:</label>
            <input {...register("position", {
              pattern: { value: /^(pres|vicepres|gensec|sportssec|girlsconvener|treasurer|sec|nota|phdrep)$/i, message: "Invalid position entered." },
              required: { value: true, message: "required" }
            })} />
            <p className="hint">
              {isAcadassoc
                ? <>Accepted values: <strong>pres</strong>, <strong>sec</strong></>
                : <>Accepted values: <strong>pres</strong>, <strong>vicepres</strong>, <strong>gensec</strong>, <strong>sportssec</strong>, <strong>girlsconvener</strong>, <strong>treasurer</strong>, <strong>nota</strong>, <strong>phdrep</strong></>
              }
            </p>
            {errors.position && <p className="error">{errors.position.message}</p>}
          </div>
        )}

        {/* Candidate name — only shown & required for ACADASSOC or CSA */}
        {needsCandidate && (
          <div>
            <label>candidate name:</label>
            <input {...register("candidatename", {
              required: { value: true, message: "required" }
            })} />
            <p className="hint">Full name of the candidate running for the position</p>
            {errors.candidatename && <p className="error">{errors.candidatename.message}</p>}
          </div>
        )}

        <div>
          <label>body of the article:</label>
          <textarea rows="10" {...register("body", { required: { value: true, message: "required" } })} />
          {errors.body && <p className="error">{errors.body.message}</p>}
        </div>

        <div>
          <label>image:</label>
          <input type="file" onChange={handleFileChange} />
        </div>

        <div>
          <input type="submit" disabled={isSubmitting} value={isSubmitting ? "Uploading..." : "Submit"} />
        </div>
      </form>
    </>
  )
}
